import Config from "../_config/config";
import myAxios from "./axiositeachWrapper";

const BASE = `${Config.nodeSiteUrl}v1/photo-gallery`;

class PhotoGalleryService {
  // Photo upload
  uploadPhotos(
    files: File[],
    albumId?: number,
    onUploadProgress?: (e: any) => void,
  ) {
    const formData = new FormData();
    files.forEach((f) => formData.append("photos", f));
    if (albumId) formData.append("albumId", String(albumId));
    return myAxios.post(`${BASE}/photos/upload`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
      onUploadProgress,
    });
  }

  updatePhoto(photoId: number, body: { caption?: string }) {
    return myAxios.put(`${BASE}/photos/${photoId}`, body);
  }

  deletePhoto(photoId: number) {
    return myAxios.delete(`${BASE}/photos/${photoId}`);
  }

  // Tagging
  tagPhotos(
    photoItemIds: number[],
    tags: { entityType: string; entityId: number }[],
  ) {
    return myAxios.post(`${BASE}/photos/tag`, { photoItemIds, tags });
  }

  untagPhoto(photoItemId: number, entityType: string, entityId: number) {
    return myAxios.delete(`${BASE}/photos/untag`, {
      data: { photoItemId, entityType, entityId },
    });
  }

  getPhotoTags(photoId: number) {
    return myAxios.get(`${BASE}/photos/${photoId}/tags`);
  }

  // Albums CRUD
  getAlbums(published?: number) {
    const params = published !== undefined ? { published } : {};
    return myAxios.get(`${BASE}/albums`, { params });
  }

  createAlbum(body: {
    name: string;
    description?: string;
    eventDate?: string;
  }) {
    return myAxios.post(`${BASE}/albums`, body);
  }

  updateAlbum(albumId: number, body: any) {
    return myAxios.put(`${BASE}/albums/${albumId}`, body);
  }

  deleteAlbum(albumId: number) {
    return myAxios.delete(`${BASE}/albums/${albumId}`);
  }

  // Album photos
  getAlbumPhotos(albumId: number, page = 1, limit = 50) {
    return myAxios.get(`${BASE}/albums/${albumId}/photos`, {
      params: { page, limit },
    });
  }

  assignPhotosToAlbum(albumId: number, photoItemIds: number[]) {
    return myAxios.post(`${BASE}/albums/${albumId}/photos`, { photoItemIds });
  }

  removePhotoFromAlbum(albumId: number, photoId: number) {
    return myAxios.delete(`${BASE}/albums/${albumId}/photos/${photoId}`);
  }

  // Share to VoilaBoard
  shareToVoilaBoard(photoItemIds: number[], boardId: number) {
    return myAxios.post(`${BASE}/photos/share-to-voilaboard`, {
      photoItemIds,
      boardId,
    });
  }
}

export default new PhotoGalleryService();
